<template>
  <span
    :class="{
      'submission-rate': true,
      'new-body-text': true,
      high: eeoPct >= 71,
      medium: eeoPct >= 31 && eeoPct < 71,
      low: eeoPct < 31,
    }"
  >
    <slot>
      {{ eeoPct }}%
    </slot>
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  fillRate: {
    type: Number,
    required: true,
  },
});

const eeoPct = computed(() => Math.round(props.fillRate));
</script>

<style lang="less" scoped>
.submission-rate {
  padding: 4px 8px;
  border-radius: 40px;

  &.high {
    background: @bg-success-light;
    color: @success;
  }

  &.medium {
    background: @bg-warning-light;
    color: @warning;
  }

  &.low {
    background: @bg-error-light;
    color: @error;
  }
}
</style>
